/**
 * Zeit- und Chip-Texte der Übersicht: heute nur die Uhrzeit, sonst Tag und Uhrzeit; die Kopf-Chips
 * nennen den spätesten Lauf je Apartment, den nächsten Lauf und die letzte Bestätigung.
 */
import {
  apartmentsLabel,
  WORKSPACE_TEXT,
  type headerFacts,
  type WorkspaceState,
} from './overviewModel';

const WEEKDAYS = ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];

export function shortTime(iso: string | null, now = new Date()): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  const sameDay = date.toDateString() === now.toDateString();
  return new Intl.DateTimeFormat(
    'de-DE',
    sameDay
      ? { hour: '2-digit', minute: '2-digit' }
      : { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' },
  ).format(date);
}

/** „Mo 19.10. – So 1.11.“ für den 14-Tage-Horizont. */
export function horizonLabel(from: string, to: string): string {
  const label = (iso: string) => {
    const date = new Date(`${iso}T00:00:00Z`);
    return `${WEEKDAYS[date.getUTCDay()]} ${date.getUTCDate()}.${date.getUTCMonth() + 1}.`;
  };
  return `${label(from)} – ${label(to)}`;
}

export function headerChips(
  facts: ReturnType<typeof headerFacts>,
  state: WorkspaceState,
  total: number,
): { big: string; text: string }[] {
  const confirmed = { big: shortTime(facts.lastConfirmed), text: 'zuletzt von Channex bestätigt' };
  if (state !== 'running') {
    return [
      { big: '0', text: `von ${apartmentsLabel(total)} automatisch` },
      { big: WORKSPACE_TEXT[state], text: 'kein Lauf geplant' },
      confirmed,
    ];
  }
  return [
    facts.lastRun
      ? {
          big: shortTime(facts.lastRun.at),
          text: `letzter Lauf · ${facts.lastRun.name} · ${facts.lastRun.changed} geändert`,
        }
      : { big: '—', text: 'noch kein Lauf' },
    facts.nextRun
      ? { big: shortTime(facts.nextRun), text: 'nächster Lauf' }
      : { big: '—', text: 'kein Lauf geplant' },
    confirmed,
  ];
}
